import React from 'react'

export default function CategoryViewSkeleton() {
  return (
    <>
      <div className='px-5 hidden sm:block md:block'>
        <div className="flex w-full py-2 h-[180px] mt-[50px] bg-gray-300 animate-pulse " >
        </div>
        {[...Array(12)].map((_, index) => (
          <div key={index} className="mb-4">
            <div className="flex w-full border border-t-0 items-center py-2">
              <div className="w-12 h-10 bg-gray-300 rounded"></div>
              <div className="flex flex-col mr-5 w-full">
                <div className="h-4 bg-gray-300 rounded w-1/3 mb-2 animate-pulse"></div>
                <div className="h-4 bg-gray-300 rounded w-2/3 animate-pulse"></div>
              </div>
            </div>
          </div>
        ))}


      </div>

      {/* desktop skleton */}
      <div className='mx-6 block sm:hidden md:hidden'>
        <div className='grid grid-cols-3 gap-4'>
          {[...Array(12)].map((category, index) => (
            <div className='bg-gray-300 rounded h-[190px] animate-pulse mt-3'>

              <div  key={index}
                className={`justify-self-center cursor-pointer   mt-3 border rounded place-self-center  relative group overflow-hidden bg-gray-200 w-24 h-24 mx-auto animate-pulse `}>
                <div className='flex flex-col items-center justify-center shadow-ex rounded items-center p-4 '>
                  <div  alt="" className='w-24 h-24' />
                  <div className='flex flex-col gap-4'>
                    <div className='font-bold text-center'></div>
                    <div className='text-sm text-center w-full text-nowradiv'></div>
                  </div>
                </div>
                <div className='absolute w-full h-full transition-all bg-[#11896C] duration-300 opacity-[10%] right-[3000px] top-0 group-hover:right-0 z-50  rounded '></div>
                <div className='absolute w-full h-full transition-all bg-[#11896C] duration-500 opacity-[5%] right-[3000px] top-0 group-hover:right-0 z-50   rounded'></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
